import { rem } from 'polished'
import React from 'react'
import { DATA_TEST_CLASS } from 'shared-constants/build/testIds'
import styled from 'styled-components'
import { Image } from 'components/Image'
import { Flex } from 'components/Layout'
import Link from 'components/Link'

import { ASPECT_RATIO } from 'components/UploadImage'
import { SCHEMA_PROPS, SCHEMA_TYPES } from 'constants/common'

const IMAGE_BASE_WIDTH = 300

export const DEFAULT_CARD_WIDTH = rem(178)

const StyledImage = styled(Image)`
  border-radius: 8px;
`

export const StrapiBrandsWidgetCard = ({
  index,
  image,
  logo,
  url,
  title,
  width = DEFAULT_CARD_WIDTH,
}) => (
  <article itemScope itemType={SCHEMA_TYPES.LIST_ITEM}>
    <Flex width={width} maxWidth={width ?? DEFAULT_CARD_WIDTH}>
      <Link
        href={url}
        aria-label={`Show products of ${title} brand`}
        itemProp={SCHEMA_PROPS.URL}
      >
        <Flex
          data-test-class={DATA_TEST_CLASS.SHOWROOM_PRODUCT_CARD}
          position="relative"
          flexDirection="column"
          height="100%"
          width="100%"
          flexShrink={0}
        >
          <StyledImage
            alt={title}
            objectFit="cover"
            aspectRatio={ASPECT_RATIO.PRODUCTS}
            src={image.url}
            baseWidth={IMAGE_BASE_WIDTH}
            itemProp={SCHEMA_PROPS.IMAGE}
          />
          <Flex mt={rem(24)} justifyContent="center">
            <Image
              alt={`${title} logo`}
              src={logo.url}
              width={logo.width}
              height={logo.height}
              style={{ width: 'auto', height: 'auto' }}
              priority
              loading="eager"
            />
          </Flex>
        </Flex>
      </Link>
    </Flex>
    <meta itemProp={SCHEMA_PROPS.POSITION} content={index + 1} />
  </article>
)
